import React from 'react';
import { containerPadding, borderRadius, shadows } from '../../utils/designTokens';

/**
 * Card - Reusable card container component
 * Ensures consistent styling across the app
 */
const Card = ({
  children,
  padding = 'comfortable',
  className = '',
  hover = false,
  onClick,
}) => {
  const paddingClass = containerPadding[padding] || containerPadding.comfortable;
  const hoverClass = hover ? 'hover:shadow-lg hover:-translate-y-1 transition-all duration-300 cursor-pointer' : '';

  return (
    <div
      className={`bg-white dark:bg-spooky-bg-medium ${borderRadius.default} ${shadows.default} ${paddingClass} ${hoverClass} ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;
